// Module
var code = "<admin-calendar ready=$ctrl.componentIsReady()></admin-calendar>";
// Exports
module.exports = code;